import { cn } from "@/lib/utils";

/**
 * Skeleton no formato da capa de um vinil — usado durante carregamentos
 * para evitar grids vazios. Mantém a mesma proporção/raio do AlbumCover.
 */
export function AlbumCoverSkeleton({
  showMeta = true,
  className,
}: {
  showMeta?: boolean;
  className?: string;
}) {
  return (
    <div className={cn("block w-full", className)}>
      <div className="relative aspect-square overflow-hidden rounded-lg bg-surface">
        <div className="absolute inset-0 animate-pulse bg-gradient-to-br from-surface via-muted/40 to-surface" />
        <div className="absolute left-1/2 top-1/2 h-1/3 w-1/3 -translate-x-1/2 -translate-y-1/2 rounded-full border border-border/40 bg-background/30" />
        <div className="absolute left-1/2 top-1/2 h-2 w-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-border/60" />
      </div>
      {showMeta && (
        <div className="mt-2.5 space-y-1.5">
          <div className="h-3 w-3/4 animate-pulse rounded bg-surface" />
          <div className="h-2.5 w-1/2 animate-pulse rounded bg-surface" />
        </div>
      )}
    </div>
  );
}

export function AlbumCoverSkeletonGrid({
  count = 12,
  showMeta = true,
  className,
}: {
  count?: number;
  showMeta?: boolean;
  className?: string;
}) {
  return (
    <div className={cn("grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6", className)}>
      {Array.from({ length: count }).map((_, i) => (
        <AlbumCoverSkeleton key={i} showMeta={showMeta} />
      ))}
    </div>
  );
}
